import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Header from '../../components/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoginNotification from "../../components/Notifications/LoginNotification";
import { faCircleArrowLeft, faUser } from '@fortawesome/free-solid-svg-icons';
import Table from '../../components/Table';
import Section from '../../components/Section';
import { useNavigate } from 'react-router-dom';
import './profile.css'

const Profile = ({ handleLogout }) => {
    const navigate = useNavigate();
    const id = localStorage.getItem('code');
    const username = localStorage.getItem('username');
    const role = localStorage.getItem('role');
    const distributor = localStorage.getItem('distributor');
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 10;
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [loading, setLoading] = useState(true);

    const permissions = useMemo(() => {
        return JSON.parse(localStorage.getItem('permissions')) || [];
    }, []);
    
    const columns = [
        { title: "No", key: "index" },
        { title: "Permisos", key: "permissions" }
    ];

    const fetchAllData = useCallback(() => {
        try {
            setLoading(true);
            if (Array.isArray(permissions)) {
                const formattedData = permissions.map((perm, index) => ({
                    number: index + 1,
                    permissions: perm
                }));
                setData(formattedData);
                setTotalItems(formattedData.length);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [permissions]);

    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);

    const renderRow = (item, index) => (
        <>
            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
            <td>{item.permissions}</td>
        </>
    );

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title='Perfil' />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(-1);
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Perfil</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label>ID</label>
                        <input
                            type="text"
                            placeholder="ID"
                            value={id}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>Nombre de usuario</label>
                        <input
                            type="text"
                            placeholder=" Nro. Factura"
                            value={username}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>Rol</label>
                        <input
                            type="text"
                            placeholder=" Nro. Factura"
                            value={role}
                            readOnly
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>Distribuidor</label>
                        <input
                            type="text"
                            placeholder=" Nro. Factura"
                            value={distributor}
                            readOnly
                        />
                    </div>
                </div>
                <div className="mobile-basic-info-form-group">
                    <Table
                        title="Lista de Permisos de Usuario"
                        rows={data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)}
                        columns={columns}
                        icon={faUser}
                        renderRow={renderRow}
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={setCurrentPage}
                        loading={loading}
                        flagPagination={true}
                    />
                </div>
            </div>
            {isLoginVisible && (
                <LoginNotification
                    message="La sesión ha expirado."
                    onClose={() => setIsLoginVisible(false)}
                />
            )}
        </div>
    );
};

export default Profile;
